const { showOverlayLoader } = useLoaderService();
export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.path != from.path) {
    showOverlayLoader();
  }
});
